// extracted by mini-css-extract-plugin
export default {"loader-icon":"loader-icon--l5__Z","loaderIcon":"loader-icon--l5__Z","rotate":"rotate--WG4Gx","shading":"shading--WTFeL","YesNo":"YesNo--N5gpm"};